import platForm from "./Here";
import circle from "@/assets/images/svg-icons/circle.svg";

let map = null;
const H = window.H;
const engineType = H.Map.EngineType.HARP;
// HARP engine is required for hybrid satellite layers (Raster Tile API v3 + Vector Tile API v2)
let maptypes = platForm.createDefaultLayers({engineType});
let geoCoderService = platForm.getSearchService();
let marker = null;
let coords = null;
let behavior = null;
let ui = null;
let trafficLayer = null;
let lineString = null;
let routeLine = null;
let position = null;
let polyline = null;
let router = null;
let bboxCircle = [];
let routeOutline = [];
let readerArray = [];
let positionArray = [];
let coordsArray = [];
let markerArray = [];
let lineArray = [];
let scheduledRoutes = [];
let scheduledRoutesArrows = [];
let executedRoutes = [];
let executedRoutesArrows = [];
let routeGroups = [];
let groupOfMarkers = [];
let baseLayer = null;
let hybridVectorLayer = null;
let currentBaseType = "normal";
const apiKey = process.env.VUE_APP_HERE_MAP_API_KEY;

// Legacy v2 style names mapped to HARP vector layers (see HERE Raster Tile API v3 migration guide)
const VECTOR_STYLE_LAYERS = {
	"normal.day": () => maptypes.vector.normal.map,
	"explore.day": () => maptypes.vector.normal.map,
	"logistics.night": () => maptypes.vector.normal.logisticsnight,
	"normal.day.grey": () => maptypes.vector.normal.lite,
	"lite.day": () => maptypes.vector.normal.lite,
	"normal.night.grey": () => maptypes.vector.normal.litenight,
	"lite.night": () => maptypes.vector.normal.litenight,
};

function clearHybridOverlay() {
	if (hybridVectorLayer) {
		map.removeLayer(hybridVectorLayer);
		hybridVectorLayer = null;
	}
}

function getTrafficLayer() {
	if (currentBaseType === "satellite") {
		return maptypes.hybrid.day.traffic;
	}
	return maptypes.vector.normal.traffic;
}

function buildRouteStyle(options) {
	return {
		lineWidth: options.lineWidth || options.strokeWeight || 8,
		strokeColor: options.strokeColor || "#ff8c34",
		lineOpacity: options.strokeOpacity != null ? options.strokeOpacity : 0.8,
		lineTailCap: "arrow-tail",
		lineHeadCap: "arrow-head",
	};
}

function addRoutePolyline(lineString, options, routeId) {
	const routePolyline = new H.map.Polyline(lineString, {
		style: buildRouteStyle(options),
	});
	routePolyline.idRoute = routeId;

	const group = new H.map.Group();
	group.addObject(routePolyline);
	map.addObject(group);
	routeGroups.push(group);

	if (routeId === "RP") {
		scheduledRoutes.push(routePolyline);
	} else if (routeId === "RE") {
		executedRoutes.push(routePolyline);
	}

	return {group, routePolyline};
}

function uiHereMap(lang, module) {
	let typeLang = "es-ES";
	if (lang === "en") {
		typeLang = "en-US";
	} else if (lang === "pt") {
		typeLang = "pt-PT";
	} else {
		typeLang = "es-ES";
	}
	ui = H.ui.UI.createDefault(map, maptypes, typeLang);
	ui.removeControl("mapsettings");
	let scalebar = ui.getControl("scalebar");
	scalebar.setAlignment("bottom-left");
	if (module !== "maps") {
		let mapsettings = new H.ui.MapSettingsControl({
			baseLayers: [
				{
					label: "normal",
					layer: maptypes.vector.normal.map,
				},
				{
					label: "satellite",
					layer: [maptypes.hybrid.day.raster, maptypes.hybrid.day.vector],
				},
				{
					label: "terrain",
					layer: maptypes.vector.normal.topo,
				},
			],
			layers: [
				{
					label: "layer.traffic",
					layer: maptypes.vector.normal.traffic,
				},
				{
					label: "layer.incidents",
					layer: maptypes.vector.normal.trafficincidents,
				},
			],
		});
		ui.addControl("customizedMapsettings", mapsettings);
	}
}

export function uiControlHereMap(lang, module) {
	if (module === null && ui != null && ui != undefined) {
		ui.removeControl("customizedMapsettings");
		ui.removeControl("zoom");
		ui.removeControl("scalebar");
		ui = null;
		uiHereMap(lang, module);
	}
}

export function initializeHereMap(data) {
	// Instantiate (and display) a map object:
	map = new H.Map(data.refs, maptypes.vector.normal.map, {
		engineType,
		zoom: data.zoom,
		center: {lng: data.lng, lat: data.lat},
	});
	addEventListener("resize", () => map.getViewPort().resize());
	// Agregar control de comportamiento
	behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
	// Agregar UI
	uiHereMap(data.lang, data.module);
	return map;
}

/* export function setMapType(type, activeTrafficLayer) {
	let addTrafficLayer = () => {
		trafficLayer = maptypes.vector.normal.traffic;
		map.addLayer(trafficLayer);
	};
	switch (type) {
		case "satellite":
			map.removeLayer(maptypes.raster.terrain.map);
			map.removeLayer(maptypes.vector.normal.map);
			map.addLayer(maptypes.raster.satellite.map);
			if (activeTrafficLayer) addTrafficLayer();
			break;
		case "terrain":
			map.removeLayer(maptypes.raster.satellite.map);
			map.removeLayer(maptypes.vector.normal.map);
			map.addLayer(maptypes.raster.terrain.map);
			if (activeTrafficLayer) addTrafficLayer();
			break;
		case "normal":
			map.removeLayer(maptypes.raster.satellite.map);
			map.removeLayer(maptypes.raster.terrain.map);
			setMapStyle("normal.day", "normal");
			if (activeTrafficLayer) addTrafficLayer();
			break;
		case "traffic":
			addTrafficLayer();
			break;
		case "traffic_clean":
			if (trafficLayer) map.removeLayer(trafficLayer);
			break;
	}
} */

/* export function setMapStyle(styleName, mapType) {
	if (mapType === "satellite" || mapType === "terrain") {
		map.removeLayer(maptypes.raster.satellite.map);
		map.removeLayer(maptypes.raster.terrain.map);
	}
	let tiles = platForm.getMapTileService({type: "base"});
	let layer = tiles.createTileLayer("maptile", styleName, 256, "png");
	map.setBaseLayer(layer);
}
 */

export function setMapType(type, activeTrafficLayer) {
	if (!map) return;

	const addTrafficLayer = () => {
		if (trafficLayer) {
			map.removeLayer(trafficLayer);
		}
		trafficLayer = getTrafficLayer();
		map.addLayer(trafficLayer);
	};

	clearHybridOverlay();

	switch (type) {
		case "satellite":
			currentBaseType = "satellite";
			map.setBaseLayer(maptypes.hybrid.day.raster);
			hybridVectorLayer = maptypes.hybrid.day.vector;
			map.addLayer(hybridVectorLayer);
			if (activeTrafficLayer) addTrafficLayer();
			break;

		case "terrain":
			currentBaseType = "terrain";
			map.setBaseLayer(maptypes.vector.normal.topo);
			if (activeTrafficLayer) addTrafficLayer();
			break;

		case "normal":
			currentBaseType = "normal";
			map.setBaseLayer(maptypes.vector.normal.map);
			if (activeTrafficLayer) addTrafficLayer();
			break;

		case "traffic":
			addTrafficLayer();
			break;

		case "traffic_clean":
			if (trafficLayer) {
				map.removeLayer(trafficLayer);
				trafficLayer = null;
			}
			break;
	}
}

export function setMapStyle(styleName) {
	if (!map) return;

	clearHybridOverlay();
	currentBaseType = "normal";

	const layerFactory = VECTOR_STYLE_LAYERS[styleName];
	if (layerFactory) {
		map.setBaseLayer(layerFactory());
		return;
	}

	// Fallback for custom raster styles via Raster Tile API v3
	const options = {style: styleName, size: 512};
	if (styleName.includes("satellite")) {
		options.format = "jpeg";
	}
	const tileService = platForm.getRasterTileService(options);
	const rasterTileProvider = new H.service.rasterTile.Provider(tileService);
	map.setBaseLayer(new H.map.layer.TileLayer(rasterTileProvider));
}

export function addMarkerHereMap(lat, lng, options, addMap = true) {
	const _opts = {
		title: "Current Position",
		icon: null,
		draggable: options.drag,
		infoWindow: {
			content: "<p>Current address:<br><strong>" + lat + ", " + lng + "</strong></p>",
		},
		info: null,
		onClick: null,
		onDragend: null,
	};
	if (options) {
		if (options.constructor === {}.constructor) {
			let size = Object.keys(options).length;
			if (size > 0) {
				if (options.title !== undefined) {
					if (options.title !== null) {
						_opts.title = options.title;
					}
				}

				if (options.icon !== undefined) {
					if (options.icon !== null) {
						_opts.icon = options.icon;
					}
				}

				if (options.draggable !== undefined) {
					if (options.draggable !== null) {
						if (options.draggable === true) {
							_opts.draggable = options.draggable;
						}
					}
				}

				if (options.infoWindow !== undefined) {
					if (options.infoWindow !== null) {
						_opts.infoWindow = options.infoWindow;
					}
				}
				if (options.info !== undefined) {
					if (options.info !== null) {
						_opts.info = options.info;
					}
				}
				if (options.label !== undefined) {
					if (options.label !== null) {
						_opts.label = options.label;
					}
				}
				if (options.onClick !== undefined) {
					if (options.onClick !== null) {
						if (typeof options.onClick === "function") {
							_opts.onClick = options.onClick;
						}
					}
				}
				if (options.onDragend != undefined) {
					if (options.onDragend != null) {
						if (typeof options.onDragend == "function") {
							_opts.onDragend = options.onDragend;
						}
					}
				}
			} else {
				console.warn("addMarker: the options size is not correct");
				return false;
			}
		} else {
			console.warn("addMarker: options is not a object");
			return false;
		}
	}
	let icon = new H.map.Icon(
		options.changeIcon
			? _opts.icon
					.replace("${ColorFill}", options.opts.fillColor)
					.replace("${ColorStroke}", options.opts.strokeColor)
					.replace("${WidthStroke}", 1)
			: _opts.icon,
		{
			size: {
				w: options.changeIcon ? 20 : 32,
				h: options.changeIcon ? 20 : 32,
			},
		}
	);
	coords = {lat, lng};
	marker = new H.map.Marker(coords, {icon}, {volatility: true});
	marker.draggable = _opts.draggable;
	marker.info = _opts.info;
	marker.label = _opts.label;
	if (addMap) map.addObject(marker);
	if (_opts.draggable === true) addDraggableMarker(marker, _opts);
	return marker;
}

export function waypointsGenerator(possitionsArray = []) {
	const arrayWaPoint = [];
	for (let i = 0; i < possitionsArray.length; i++) {
		arrayWaPoint.push(possitionsArray[i].lat + "," + possitionsArray[i].lng);
	}
	return arrayWaPoint;
}

export function addInfoBubble(marker, html) {
	marker.setData(html);
	marker.addEventListener(
		"tap",
		function (evt) {
			map.setCenter(evt.target.getGeometry());
			// event target is the marker itself, group is a parent event target
			// for all objects that it contains
			let bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
				// read custom data
				content: evt.target.getData(),
			});
			//remove infobubbles
			ui.getBubbles().forEach((bub) => ui.removeBubble(bub));
			// show info bubble
			ui.addBubble(bubble);
		},
		false
	);
}

export function calculateHereRoute(possitionsArray = [], options) {
	const waypts = waypointsGenerator(possitionsArray);
	let origin = waypts[0];
	let destination = waypts[waypts.length - 1];
	const logLengthPerPiece = 200;
	let ArrayofArray = [];
	let routingParameters = {
		routingMode: "fast",
		transportMode: "car",
		// The start point of the route:
		origin: origin,
		// The end point of the route:
		destination: destination,
		// Include the route shape in the response
		return: "polyline",
	};
	const onResult = function (result) {
		// ensure that at least one route was found
		if (result.routes.length) {
			result.routes[0].sections.forEach((section) => {
				lineString = H.geo.LineString.fromFlexiblePolyline(section.polyline);
				addRoutePolyline(lineString, options, options.id || "RP");
			});
		}
	};
	//This functionality is performed in this way due to waypoint limits and here maps has not yet provided a solution.
	for (let i = 0; i < waypts.length; i += logLengthPerPiece) {
		let pedazo = waypts.slice(i, i + logLengthPerPiece);
		ArrayofArray.push(pedazo);
	}
	for (let i = 0; i < ArrayofArray.length; i++) {
		(routingParameters.via = new H.service.Url.MultiValueQueryParameter(ArrayofArray[i])),
			// Get an instance of the routing service version 8:
			(router = platForm.getRoutingService(null, 8));
		router.calculateRoute(routingParameters, onResult, (err) => {
			throw new Error(err.message);
		});
	}
}

export function calculateRouteSnapToRoad(possitionsArray = [], options) {
	const waypts = waypointsGenerator(possitionsArray);
	let origin = waypts[0];
	let destination = waypts[waypts.length - 1];
	let ArrayofArray = [];
	const logLengthPerPiece = 200;
	let routingParameters = {
		routingMode: "fast",
		transportMode: "pedestrian",
		origin: origin,
		destination: destination,
		return: "polyline",
	};
	const onResult = function (result) {
		// ensure that at least one route was found
		if (result.routes.length) {
			let boundsGroup = new H.map.Group();
			result.routes[0].sections.forEach((section) => {
				lineString = H.geo.LineString.fromFlexiblePolyline(section.polyline);
				const {group} = addRoutePolyline(lineString, options, options.id || "RE");
				boundsGroup.addObject(group);
			});
			map.getViewPort().setPadding(150, 10, 20, 10);
			map.getViewPort().resize();
			map.getViewModel().setLookAtData({
				bounds: boundsGroup.getBoundingBox(),
			});
		}
	};
	//This functionality is performed in this way due to waypoint limits and here maps has not yet provided a solution.
	for (let i = 0; i < waypts.length; i += logLengthPerPiece) {
		let pedazo = waypts.slice(i, i + logLengthPerPiece);
		ArrayofArray.push(pedazo);
	}
	for (let i = 0; i < ArrayofArray.length; i++) {
		(routingParameters.via = new H.service.Url.MultiValueQueryParameter(ArrayofArray[i])),
			// Get an instance of the routing service version 8:
			(router = platForm.getRoutingService(null, 8));
		router.calculateRoute(routingParameters, onResult, (err) => {
			throw new Error(err.message);
		});
	}
}

export function centerHereMap(lat, lng, options) {
	if (map) {
		map.setCenter({lat, lng});
		if (options) {
			if (options.constructor === {}.constructor) {
				let size = Object.keys(options).length;
				if (size > 0) {
					if (options.zoom !== undefined && options.zoom !== null) {
						if (options.zoom >= 0 && options.zoom <= 18) {
							map.setZoom(options.zoom);
						}
					}
				} else {
					console.warn("centerMap: the options size is not correct");
					return false;
				}
			} else {
				console.warn("centerMap: options is not a object");
				return false;
			}
		}
	}
}

export function changeIconInMarkerHereMap(marker, newIconMarker) {
	let icon = new H.map.Icon(newIconMarker, {size: {w: 32, h: 32}});
	marker.setIcon(icon);
}

export function changeRouteProperties({strokeColor, strokeOpacity, lineWidth, strokeWeight, id}) {
	const width = lineWidth || strokeWeight;
	const style = buildRouteStyle({strokeColor, strokeOpacity, lineWidth: width});
	const routes = id === "RP" ? scheduledRoutes : executedRoutes;

	routes.forEach((routePolyline) => {
		if (routePolyline && routePolyline.idRoute === id) {
			routePolyline.setStyle(style);
		}
	});
}

export function clearMap() {
	if (map) {
		map.removeObjects(map.getObjects());
		ui.getBubbles().forEach((bub) => ui.removeBubble(bub));
	}
	routeGroups = [];
	scheduledRoutes = [];
	scheduledRoutesArrows = [];
	executedRoutes = [];
	executedRoutesArrows = [];
}

export function zoomMap(value) {
	map.setZoom(value);
}

export function fitBoundsMarkerGroup(markerArray = []) {
	let group = new H.map.Group();
	group.addObjects(markerArray);
	map.addObject(group);
	map.getViewPort().setPadding(250, 250, 250, 250);
	map.getViewPort().resize();
	map.getViewModel().setLookAtData({bounds: group.getBoundingBox()});
}

export function addDraggableMarker(markerDraggable, _opts) {
	// disable the default draggability of the underlying map
	// and calculate the offset between mouse and target's position
	// when starting to drag a marker object:
	markerDraggable.addEventListener(
		"dragstart",
		function (ev) {
			let target = ev.target,
				pointer = ev.currentPointer;
			if (target instanceof H.map.Marker) {
				let targetPosition = map.geoToScreen(target.getGeometry());
				target["offset"] = new H.math.Point(
					pointer.viewportX - targetPosition.x,
					pointer.viewportY - targetPosition.y
				);
				behavior.disable();
			}
		},
		false
	);
	// re-enable the default draggability of the underlying map
	// when dragging has completed
	markerDraggable.addEventListener(
		"dragend",
		function (ev) {
			let target = ev.target;
			if (target instanceof H.map.Marker) {
				behavior.enable();
			}
			let pos = {
				lat: markerDraggable.getGeometry().lat,
				lng: markerDraggable.getGeometry().lng,
			};
			const location = "";
			_opts.onDragend(markerDraggable, pos);
		},
		false
	);
	// Listen to the drag event and move the position of the marker
	// as necessary
	markerDraggable.addEventListener(
		"drag",
		function (ev) {
			let target = ev.target,
				pointer = ev.currentPointer;
			if (target instanceof H.map.Marker) {
				target.setGeometry(
					map.screenToGeo(pointer.viewportX - target["offset"].x, pointer.viewportY - target["offset"].y)
				);
			}
		},
		false
	);
}

export const reverseGeoCode = (coords) => {
	if (coords === undefined || coords === null) {
		console.warn("inverseGeocoder: missing parameter coords");
		return false;
	}
	if (coords.constructor != {}.constructor) {
		console.warn("inverseGeocoder: coords must be an Object");
		return false;
	}
	if (!coords.hasOwnProperty("lat") && !coords.hasOwnProperty("lng")) {
		console.warn("inverseGeocoder: missing lat or lng attributes");
		return false;
	}
	return new Promise((resolve, reject) => {
		geoCoderService.reverseGeocode(
			{
				at: coords.lat + "," + coords.lng,
			},
			(result) => {
				resolve(result);
			},
			(error) => {
				console.warn("inverseGeocoder was not successful for the following reason:");
				reject(error);
			}
		);
	});
};

export function hereMapsFullScreenControl(ui) {
	// add custom UI control
	const myCustomControl = new H.ui.Control();
	myCustomControl.addClass("customControl");
	ui.addControl("myCustomControl", myCustomControl);
	// Set the position of the control in the UI's layout
	myCustomControl.setAlignment(H.ui.LayoutAlignment.TOP_RIGHT);

	const myCustomPanel = new H.ui.base.OverlayPanel();
	myCustomPanel.addClass("customPanel");
	myCustomControl.addChild(myCustomPanel);

	// store original styles
	const mapDiv = ui.getMap().getElement();
	let divStyle = mapDiv.style;
	if (mapDiv.runtimeStyle) {
		divStyle = mapDiv.runtimeStyle;
	}
	const originalPos = divStyle.position;
	let originalWidth = divStyle.width;
	let originalHeight = divStyle.height;
	// ie8 hack
	if (originalWidth === "") {
		originalWidth = mapDiv.style.width;
	}
	if (originalHeight === "") {
		originalHeight = mapDiv.style.height;
	}
	const originalTop = divStyle.top;
	const originalLeft = divStyle.left;
	const originalZIndex = divStyle.zIndex;
	let bodyStyle = document.body.style;
	if (document.body.runtimeStyle) {
		bodyStyle = document.body.runtimeStyle;
	}
	const originalOverflow = bodyStyle.overflow;

	const myCustomButton = new H.ui.base.PushButton({
		label: "Full screen",
		onStateChange: (evt) => {
			// OK, button state changed... if it's currently down
			if (myCustomButton.getState() === H.ui.base.Button.State.DOWN) {
				// go full screen
				mapDiv.style.position = "fixed";
				mapDiv.style.width = "100%";
				mapDiv.style.height = "100%";
				mapDiv.style.top = "0";
				mapDiv.style.left = "0";
				mapDiv.style.zIndex = "100";
				document.body.style.overflow = "hidden";
			} else {
				// exit full screen
				if (originalPos === "") {
					mapDiv.style.position = "relative";
				} else {
					mapDiv.style.position = originalPos;
				}
				mapDiv.style.width = originalWidth;
				mapDiv.style.height = originalHeight;
				mapDiv.style.top = originalTop;
				mapDiv.style.left = originalLeft;
				mapDiv.style.zIndex = originalZIndex;
				document.body.style.overflow = originalOverflow;
			}
			ui.getMap().getViewPort().resize();
		},
	});

	myCustomPanel.addChild(myCustomButton);
	myCustomPanel.setState(H.ui.base.OverlayPanel.State.OPEN);
}

export function getHereMapObj() {
	return map;
}

export const getCurrentPosition = () => {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition((position) => {
			centerHereMap(position.coords.latitude, position.coords.longitude, null);
			zoomMap(11);
			geoCoderService.reverseGeocode(
				{
					at: position.coords.latitude + "," + position.coords.longitude,
				},
				(result) => {
					return result;
				},
				(error) => {
					console.error("getCurrentPosition: Error code", error.code);
					console.error("getCurrentPosition: Error message", error.message);
				}
			);
		});
	} else {
		console.error("getCurrentPosition: Your browser doesnt support Geolocation");
	}
};

export function showGeoJSONData(geoJson) {
	let data = JSON.stringify(geoJson);
	let reader = new H.data.geojson.Reader(undefined, {
		disableLegacyMode: true,
		// This function is called each time parser detects a new map object
		style: function (mapObject) {
			if (mapObject instanceof H.map.Polygon) {
				mapObject.setStyle({
					fillColor: "rgba(255,248,0, 0.5)",
					strokeColor: "#F4710C",
					lineWidth: 2,
				});
				mapObject.addEventListener(
					"tap",
					function (evt) {
						position = map.screenToGeo(evt.currentPointer.viewportX, evt.currentPointer.viewportY);
						map.setCenter(position);
						let bubble = new H.ui.InfoBubble(position, {
							content: mapObject["data"]["name"],
						});
						ui.getBubbles().forEach((bub) => ui.removeBubble(bub));
						ui.addBubble(bubble);
					},
					false
				);
			}
		},
	});
	reader.parseData(data);
	let layer = reader.getLayer();
	readerArray.push(layer);
	map.addLayer(layer);
}

export function removeGeoJsonLayer() {
	for (let layer in readerArray) {
		map.removeLayer(readerArray[layer]);
		delete readerArray[layer];
	}
}

export function removeGeoJsonLayerById() {
	for (let layer in readerArray) {
		if (parseInt(layer) === readerArray.length - 1) {
			map.removeLayer(readerArray[layer]);
			delete readerArray[layer];
		}
	}
}

export function selectTool(opc, global) {
	switch (opc) {
		case "marker":
			break;
		case "circle":
			break;
		case "polygon":
			drawPolygonHereMap(global, global.activeTab);
		case "polyline":
			break;
		case "rectangle":
			break;
		default:
			drawPolygonHereMap(null, null);
			clearMap();
			break;
	}
}

export function addPolylineToMap(
	data,
	opts = {
		strokeColor: "rgba(54,55,56,0.7)",
		strokeWeight: 3,
		strokeOpacity: 1,
	}
) {
	if (data.length > 0) {
		lineString = new H.geo.LineString();
		data.forEach(function (point) {
			lineString.pushPoint(point);
		});
		polyline = new H.map.Polyline(lineString, {
			style: {
				lineWidth: opts.strokeWeight,
				strokeColor: opts.strokeColor,
				fillOpacity: opts.strokeOpacity,
			},
		});
		lineArray.push(polyline);
		map.addObject(polyline);
		return polyline;
	}
}

export function drawPolygonHereMap(thisObject, tab) {
	markerArray = [];
	positionArray = [];
	coordsArray = [];
	const cursor = document.querySelector(".map");
	if (tab === 1) {
		if (cursor != null) cursor.style.cursor = "crosshair";
		let icon = null;
		let marker = null;
		let cont = 0;
		map.addEventListener("tap", (event) => {
			if (thisObject.activeTab === 1 && cursor.style.cursor !== "default") {
				position = map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
				positionArray.push(position);
				coordsArray.push([position.lng, position.lat]);
				icon = new H.map.Icon(circle, {size: {w: 8, h: 8}});
				marker = new H.map.Marker(position, {icon});
				markerArray.push(marker);
				map.addObject(marker);
				addPolylineToMap(positionArray);
				if (markerArray.length >= 3 && cont === 1) {
					// event listener for vertice markers group to change the cursor to pointer
					markerArray[0].addEventListener(
						"pointerenter",
						function () {
							cursor.style.cursor = "pointer";
						},
						true
					);

					// event listener for vertice markers group to change the cursor to default
					markerArray[0].addEventListener(
						"pointerleave",
						function () {
							cursor.style.cursor = "default";
						},
						true
					);

					markerArray[0].addEventListener("tap", function () {
						let geoJson = {
							type: "FeatureCollection",
							features: [
								{
									type: "Feature",
									geometry: {
										type: "Polygon",
										coordinates: [coordsArray],
									},
								},
							],
						};
						showGeoJSONData(geoJson);
						thisObject.callbackDraw(geoJson["features"][0]["geometry"]);
					});
				}
				cont++;
			}
		});
	} else {
		cursor.style.cursor = "default";
	}
}

export function setMapViewBounds(coords) {
	let bbox = new H.geo.Rect(
		coords["properties"]["ymin"],
		coords["properties"]["xmin"],
		coords["properties"]["ymax"],
		coords["properties"]["xmax"]
	);
	map.getViewPort().setPadding(20, 10, 20, 10);
	map.getViewPort().resize();
	map.getViewModel().setLookAtData({
		bounds: bbox,
	});
}

export function addCircleToMap(options = {center: {lat: 4.1156735, lng: -72.9301367}, radius: 200}) {
	let drawCircle = new H.map.Circle(options.center, options.radius, {
		style: {
			strokeColor: "rgba(56, 120, 199, 1)",
			lineWidth: 0.8,
			fillColor: "rgba(255, 255, 0, 0.2)",
		},
	});
	map.addObject(drawCircle);
	bboxCircle.push(drawCircle);
	map.getViewPort().setPadding(20, 20, 20, 20);
	map.getViewPort().resize();
	map.getViewModel().setLookAtData({bounds: drawCircle.getBoundingBox()});
}

export function removeRoute() {
	if (!map) return;

	routeGroups.forEach((group) => {
		map.removeObject(group);
	});
	routeGroups = [];
	scheduledRoutes = [];
	scheduledRoutesArrows = [];
	executedRoutes = [];
	executedRoutesArrows = [];

	if (routeOutline.length > 0) {
		for (let i = 0; i <= routeOutline.length; i++) {
			if (routeOutline[i]) {
				map.removeObject(routeOutline[i]);
			}
		}
		routeOutline = [];
	}
}

export function removeCircle() {
	if (bboxCircle.length > 0) {
		map.removeObject(bboxCircle[0]);
		bboxCircle = [];
	}
}

export function removeMarker(marker) {
	if (marker) {
		map.removeObject(marker);
		ui.getBubbles().forEach((bub) => ui.removeBubble(bub));
	}
}

export function removePolylines() {
	if (lineArray.length > 0) {
		for (let i = 0; i <= lineArray.length; i++) {
			map.removeObject(lineArray[i]);
		}
		lineArray = [];
	}
}

export function removePolyline(polyline) {
	if (polyline) {
		map.removeObject(polyline);
	}
}

export function addGroupOfMarkers(
	markerLocations = [],
	opts = {
		strokeColor: "#FF0000",
		fillColor: "#000000",
		strokeOpacity: 0.5,
		strokeWeight: 8,
		label: false,
	}
) {
	let svgText = "";
	groupOfMarkers = [];
	const km_formatter = (num) => (num * 1000 >= 1000 ? `${num.toFixed(2)} Km` : `${(num * 1000).toFixed(2)} Mt`);
	markerLocations.forEach(({lat, lng, ...resto}, index) => {
		let point = {lat: +lat, lng: +lng};
		if (opts.label) {
			svgText = " " + (index + 1);
		}
		const iconSvg =
			'<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">' +
			'<circle cx="25" cy="25" r="25" fill="${ColorFill}" stroke="${ColorStroke}" stroke-width="${WidthStroke}" />' +
			'<text x="50%" y="50%" font-size="20pt" font-family="Arial" font-weight="bold" text-anchor="middle" fill="white" dy=".3em">' +
			svgText +
			"</text></svg>".trim();
		const makerObject = {
			position: point,
			infoWindow: {
				content: `<div style="width: 210px;display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
                    <div>
                        <h5 class="mb-2">${this.$t("MapModule.TrackingInformation")}</h5>
                        <p><span class="font-bold text-sm"> ${this.$t("Date")}:</span> ${resto.date}</p>
                        <p><span class="font-bold text-sm"> ${this.$t("Hour")}:</span> ${resto.time}</p>
                        <p><span class="font-bold text-sm"> ${this.$t("RoutesLegends.Distance")}:</span> ${km_formatter(
					+resto.accumulated_distance
				)}</p>

                <p><span class="font-bold text-sm"> ${this.$t("Alarm.Speed")}:</span> ${resto.max_speed} Km/h</p>

                    </div>
                    <div class="con-vs-chip product-order-status vs-chip-primary con-color mt-4" style="color: rgba(255, 255, 255, 0.9);">
                       <span class="font-bold text-sm"> &nbsp; &nbsp;${
							" " + (index + 1) + " / " + markerLocations.length
						}</span>
                    </div>
                </div>`,
			},
			title: " " + (index + 1),
			icon: iconSvg,
			changeIcon: true,
			opts,
		};
		let markers = addMarkerHereMap(point.lat, point.lng, makerObject, true);
		groupOfMarkers.push(markers);
		addInfoBubble(markers, makerObject.infoWindow.content);
	});
}

// Removes the markers from the map, but keeps them in the array.
export function hideMarkers() {
	for (let i = 0; i < groupOfMarkers.length; i++) {
		groupOfMarkers[i].setVisibility(false);
	}
}

// Hide o show and existing polyline object
export function togglePolyline(flightPath, toggleVal) {
	if (flightPath.visible && toggleVal) return;
	flightPath.setVisibility(toggleVal);
}

// Shows any markers currently in the array.
export function enableMarkerLabel(val) {
	for (let i = 0; i < groupOfMarkers.length; i++) {
		const opts = {
			text: " " + (i + 1),
			strokeColor: val.opt.strokeColor || "#FF0000",
			fillColor: val.opt.waypointsColor || "#000000",
			strokeOpacity: val.opt.strokeOpacity || 0.5,
			strokeWeight: val.opt.strokeWeight || 8,
			label: false,
		};
		if (val.showLabel) {
			const iconSvgLabel =
				'<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">' +
				'<circle cx="25" cy="25" r="25" fill="${ColorFill}" stroke="${ColorStroke}" stroke-width="${WidthStroke}" />' +
				'<text x="50%" y="50%" font-size="20pt" font-family="Arial" font-weight="bold" text-anchor="middle" fill="white" dy=".3em">' +
				opts.text +
				"</text></svg>".trim();
			const parsedSvg = iconSvgLabel
				.replace("${ColorFill}", opts.fillColor)
				.replace("${ColorStroke}", opts.strokeColor)
				.replace("${WidthStroke}", "1");
			let icon = new H.map.Icon(parsedSvg, {size: {w: 20, h: 20}});
			groupOfMarkers[i].setIcon(icon);
		} else {
			const iconSvg =
				'<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">' +
				'<circle cx="25" cy="25" r="25" fill="${ColorFill}" stroke="${ColorStroke}" stroke-width="${WidthStroke}" />' +
				"</svg>".trim();
			const parsedSvg = iconSvg
				.replace("${ColorFill}", opts.fillColor)
				.replace("${ColorStroke}", opts.strokeColor)
				.replace("${WidthStroke}", "1");
			let icon = new H.map.Icon(parsedSvg, {size: {w: 20, h: 20}});
			groupOfMarkers[i].setIcon(icon);
		}
	}
}

// Shows any markers currently in the array.
export function changeAuxiliaryRouteOptions(
	flightPath,
	{lineWaypointsStrokeColor, lineWaypointsStrokeOpacity, lineWaypointsStrokeWeight}
) {
	flightPath.setStyle({
		strokeColor: lineWaypointsStrokeColor,
		strokeOpacity: lineWaypointsStrokeOpacity,
		strokeWeight: lineWaypointsStrokeWeight,
	});
}

export function ease(
	startCoord = {lat: 0, lng: 0},
	durationMs = 200,
	onStep = console.log,
	onComplete = function () {}
) {
	let forward = true;
	let endCoord = map.getCenter().walk(Math.random() * 360, Math.random() * 450000);
	let raf =
			window.requestAnimationFrame ||
			function (f) {
				window.setTimeout(f, 16);
			},
		currentValueLat = startCoord.lat,
		currentValueLng = startCoord.lng,
		startPos = startCoord,
		endPos = endCoord,
		currentSinValue = 0;

	function step() {
		const interval = setInterval(() => {
			marker.setGeometry(endPos);
			forward = !forward;
		}, 3000);
	}

	raf(step);
}

export function addDomMarker(coords, label = "") {
	let outerElement = document.createElement("div"),
		innerElement = document.createElement("div");
	outerElement.style.userSelect = "none";
	outerElement.style.webkitUserSelect = "none";
	outerElement.style.msUserSelect = "none";
	outerElement.style.mozUserSelect = "none";
	outerElement.style.cursor = "default";
	innerElement.style.color = "white";
	innerElement.style.backgroundColor = "#2c2c2c";
	innerElement.style.border = "2px solid #2c2c2c";
	innerElement.style.font = "normal 12px arial";
	innerElement.style.lineHeight = "12px";
	innerElement.style.paddingTop = "2px";
	innerElement.style.paddingLeft = "4px";
	innerElement.style.width = "20px";
	innerElement.style.height = "20px";
	innerElement.style.marginTop = "-45px";
	innerElement.style.marginLeft = "10px";
	outerElement.appendChild(innerElement);
	// Add text to the DOM element
	innerElement.innerHTML = label;
	let domIcon = new H.map.DomIcon(outerElement);
	// Marker for Chicago Bears home
	let bearsMarker = new H.map.DomMarker(coords, {
		icon: domIcon,
	});
	map.addObject(bearsMarker);
}

export function addClickEvent(callbacFunction) {
	map.addEventListener("tap", (event) => {
		callbacFunction && callbacFunction(event);
	});
}
export function clearInformationOnMapControl(position = "top-left") {
	const mapContainer = map.getElement();
	if (!mapContainer) return;
	// Normalizar la clase CSS con base en posición
	const positionClass = `custom-control-${position}`;
	// Buscar el control por clase
	const control = mapContainer.querySelector(`.${positionClass}`);
	if (control) {
		control.remove();
	}
}

export function displayInformationOnMapControl(info, position = "TOP_LEFT") {
	// Validar info
	if (typeof info !== "string" && !(info instanceof HTMLElement)) {
		console.warn("displayInformationOnMapControl: info must be a string or HTMLElement");
		return;
	}
	const mapContainer = map.getElement();
	const positionClassMap = {
		TOP_LEFT: {top: "10px", left: "10px"},
		TOP_CENTER: {top: "10px", left: "50%", transform: "translateX(-50%)"},
		TOP_RIGHT: {top: "10px", right: "10px"},
		BOTTOM_LEFT: {bottom: "10px", left: "10px"},
		BOTTOM_CENTER: {bottom: "10px", left: "50%", transform: "translateX(-50%)"},
		BOTTOM_RIGHT: {bottom: "10px", right: "10px"},
		LEFT_TOP: {top: "10px", left: "10px"},
		RIGHT_TOP: {top: "10px", right: "10px"},
		LEFT_CENTER: {top: "50%", left: "10px", transform: "translateY(-50%)"},
		RIGHT_CENTER: {top: "50%", right: "10px", transform: "translateY(-50%)"},
		LEFT_BOTTOM: {bottom: "10px", left: "10px"},
		RIGHT_BOTTOM: {bottom: "10px", right: "10px"},
	};
	const stylePosition = positionClassMap[position] || positionClassMap["TOP_LEFT"];
	// Primero, limpiar controles anteriores de esa posición si existen
	const oldControl = mapContainer.querySelector(`.custom-map-control-${position}`);
	if (oldControl) oldControl.remove();
	const infoDiv = document.createElement("div");
	infoDiv.className = `custom-map-control-${position}`;
	infoDiv.style.position = "absolute";
	infoDiv.style.zIndex = 999;
	infoDiv.style.backgroundColor = "white";
	infoDiv.style.padding = "10px";
	infoDiv.style.borderRadius = "5px";
	infoDiv.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
	infoDiv.style.textAlign = "justify";
	infoDiv.style.fontFamily = "Arial, sans-serif";
	infoDiv.style.fontSize = "14px";
	infoDiv.style.pointerEvents = "auto";
	// Asignar la posición CSS
	Object.assign(infoDiv.style, stylePosition);
	if (typeof info === "string") {
		infoDiv.innerHTML = info;
	} else {
		infoDiv.appendChild(info);
	}
	// Añadir al mapa
	mapContainer.appendChild(infoDiv);
}

function decodePath(str, precision) {
	let index = 0,
		lat = 0,
		lng = 0,
		coordinates = [],
		shift = 0,
		result = 0,
		byte = null,
		latitude_change,
		longitude_change,
		factor = Math.pow(10, precision || 5);

	while (index < str.length) {
		byte = null;
		shift = 0;
		result = 0;
		do {
			byte = str.charCodeAt(index++) - 63;
			result |= (byte & 0x1f) << shift;
			shift += 5;
		} while (byte >= 0x20);
		latitude_change = result & 1 ? ~(result >> 1) : result >> 1;
		shift = result = 0;
		do {
			byte = str.charCodeAt(index++) - 63;
			result |= (byte & 0x1f) << shift;
			shift += 5;
		} while (byte >= 0x20);
		longitude_change = result & 1 ? ~(result >> 1) : result >> 1;
		lat += latitude_change;
		lng += longitude_change;
		coordinates.push([lat / factor, lng / factor]);
	}
	return coordinates;
}

export function drawPolyline(paths, options) {
	if (map && paths) {
		let _opts = {
			strokeColor: options.strokeColor,
			fillOpacity: options.strokeOpacity,
			lineWidth: options.strokeWeight,
			toRemove: null,
			info: null,
		};
		if (paths.constructor !== [].constructor) {
			if (typeof paths === "string") {
				paths = decodePath(paths, 5);
			} else {
				console.warn("drawPolyline: paths must be an Array");
				return false;
			}
		}

		if (paths.length <= 0) {
			console.warn("drawPolyline: paths must have at least item");
			return false;
		}

		if (options) {
			if (options.constructor === {}.constructor) {
				let size = Object.keys(options).length;
				if (size > 0) {
					if (options.strokeColor !== undefined) {
						if (options.strokeColor !== null) {
							if (options.strokeColor !== "") {
								_opts.strokeColor = options.strokeColor;
							}
						}
					}

					if (options.strokeOpacity !== undefined) {
						if (options.strokeOpacity !== null) {
							if (Number.isInteger(options.strokeOpacity)) {
								if (options.strokeOpacity >= 1 && options.strokeOpacity <= 10) {
									_opts.strokeOpacity = options.strokeOpacity;
								}
							}
						}
					}

					if (options.strokeWeight !== undefined) {
						if (options.strokeWeight !== null) {
							if (Number.isInteger(options.strokeWeight)) {
								if (options.strokeWeight >= 1 && options.strokeWeight <= 10) {
									_opts.strokeWeight = options.strokeWeight;
								}
							}
						}
					}

					if (options.toRemove !== undefined) {
						if (options.toRemove !== null) {
							if (options.toRemove !== "") {
								_opts.toRemove = options.toRemove;
							}
						}
					}

					if (options.info !== undefined) {
						if (options.info !== null) {
							_opts.info = options.info;
						}
					}
				} else {
					console.warn("drawPolyline: the options size is not correct");
					return false;
				}
			} else {
				console.warn("drawPolyline: options is not a object");
				return false;
			}
		}
		switch (_opts.toRemove) {
			case "all":
				clearMap();
				break;
			case "polygons":
				removeGeoJsonLayer();
				break;
			case "polylines":
				removePolyline();
				break;
			default:
				break;
		}
		lineString = new H.geo.LineString();
		paths.forEach(function (point) {
			lineString.pushPoint({lat: point[0], lng: point[1]});
		});
		routeOutline = new H.map.Polyline(lineString, {
			style: {
				lineWidth: _opts.lineWidth,
				strokeColor: _opts.strokeColor,
			},
		});
		routeOutline.info = _opts.info;
		return map.addObject(routeOutline);
	} else {
		return false;
	}
}
